import React from "react";
import Navbar from "../../components/navbar/Navbar";
import FormPost from "../../components/post/createPost/FormPost";
import "./create_post.css";
const CreatePost = () => {
  return (
    <React.Fragment>
      <Navbar otherPage={true} />
      <FormPost />
    </React.Fragment>
  );
};

export default CreatePost;
